export default "__VITE_ASSET___MNVPtWn__"